import { SourceBasedExpression } from '../Expression.js';
export class ToIntegerExpression extends SourceBasedExpression {
    evaluate(visitor, localVariables) {
        const source = this.getSource().evaluate(visitor, localVariables);
        return parseInt(source, 10);
    }
}
//# sourceMappingURL=ToIntegerExpression.js.map